import React from "react";
import type { TFunction } from "i18next";
import type { Module } from "src/system/module.types.ts";
import { ResourceEnum } from "src/constants/constants.ts";
import type { MarketingCompanyResource } from "@exonn/js-sdk";

export const module: Module<MarketingCompanyResource> = {
  id: ResourceEnum.MarketingCompany,
  bigIcon: <i className="icon-20-market_comp" />,
  smallIcon: <i className="icon-15-market_comp" />,
  name: (t: TFunction) => t("moduleName.marketing-company"),
  tabs: {
    edit: {
      getTitle: (resource) => resource.name,
    },
  },
  formTabs: {
    general: {
      title: (t) => t("formTabs.general.title"),
    },
    email: {
      title: (t) => t("formTabs.email.title"),
    },
    sms: {
      title: (t) => t("formTabs.sms.title"),
    },
  },
};
